import { render, staticRenderFns } from "./note_awards_list.vue?vue&type=template&id=e55c100a"
import script from "./note_awards_list.vue?vue&type=script&lang=js"
export * from "./note_awards_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports